import React, { FC, useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Breadcumb, MainLayout, Header } from 'components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useAutoApproval } from 'hooks/useAutoApproval';
import ParseTextWithBreaklines from 'utils/ParseTextWithBreaklines';
import Loader from 'components/Loader';

import { format } from 'date-fns/esm';
import CoursesDetails from './coursersInfo';
import texts from './texts';
import { ContainerStyled, CreateActivelButton, ContentBotton } from './style';

import ConfirmModal from '../../modals/confirm-detal-modal';

export interface CourseTableListDTO {
  id: number;
  cursoId: number;
  limiteVagas: string;
  vagas: number;
  mensalidade: number;
  nome: string;
  turno: string;
  percentual: number;
  campus: string;
}
const Revisao: FC = () => {
  const {
    currentFormData,
    isLoading,
    getCurrentAutoApproval,
  } = useAutoApproval();

  const history = useHistory();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const initRequests = useCallback(async () => {
    if (currentFormData.aprovacaoId) {
      getCurrentAutoApproval(currentFormData.aprovacaoId);
    } else {
      history.push('/aprovacao-automatica');
    }
  }, [currentFormData]);

  useEffect(() => {
    initRequests();
  }, []);

  const backAutoApprovalMenu = () => {
    history.push('/aprovacao-automatica');
  };

  const getFormattedDate = (date?: Date) => {
    return date ? format(new Date(date), 'dd/MM/yyyy') : '';
  };

  return (
    <>
      <MainLayout>
        <Breadcumb />
        <ContainerStyled>
          <Header />
          {isLoading ? (
            <Loader />
          ) : (
            <Container>
              <Row>
                <legend className="marginb-less">Revise suas escolhas</legend>
                <br />
                <p>
                  Antes de continuar, confira se todos os dados estão corretos.
                  Tenha muita atenção.
                </p>
              </Row>

              <Row>
                <Col md="auto" className="box-container">
                  <Col>
                    <label className="box-container-label">
                      Nome da automação:
                    </label>
                  </Col>
                  <Col className="box-container-data">
                    {currentFormData?.aprovacaoNome}
                  </Col>
                </Col>

                {currentFormData?.status === 'A' ? (
                  <Col md="auto" />
                ) : (
                  <Col md="auto">
                    <Link
                      className="link-editar"
                      to="/aprovacao-automatica/edit"
                    >
                      Editar
                    </Link>
                  </Col>
                )}
              </Row>

              <br />
              <Row>
                <Col md="auto" className="box-container">
                  <Col>
                    <label className="box-container-label">Público-alvo:</label>
                  </Col>
                  <Col className="box-container-data">
                    {(() => {
                      switch (currentFormData?.tipo) {
                        case 'V':
                          return 'Veteranos';
                        case 'C':
                          return 'Calouros';
                        case 'CV':
                          return 'Veteranos e calouros';
                        default:
                          return 'Todos';
                      }
                    })()}
                  </Col>
                </Col>
                {currentFormData?.status === 'A' ? (
                  <Col />
                ) : (
                  <Col>
                    <Link
                      className="link-editar"
                      to="/aprovacao-automatica/edit"
                    >
                      Editar
                    </Link>
                  </Col>
                )}
              </Row>
              <br />

              <Row>
                <Col md="auto" className="box-container">
                  <Col>
                    <label className="box-container-label">
                      Período para Inscrição:
                    </label>
                  </Col>
                  <Col className="box-container-data">
                    {`${getFormattedDate(
                      currentFormData?.prazoInicial,
                    )} até ${getFormattedDate(currentFormData?.prazoFinal)}`}
                  </Col>
                </Col>
                {currentFormData?.status === 'A' ? (
                  <Col />
                ) : (
                  <Col>
                    <Link
                      className="link-editar"
                      to="/aprovacao-automatica/edit"
                    >
                      Editar
                    </Link>
                  </Col>
                )}
              </Row>
              <br />

              <CoursesDetails />

              <ContentBotton>
                <ParseTextWithBreaklines text={texts.firstParagraph} />
                <CreateActivelButton
                  onClick={
                    currentFormData?.status === 'A'
                      ? () => backAutoApprovalMenu()
                      : () => setIsConfirmModalOpen(true)
                  }
                >
                  {currentFormData?.status === 'A'
                    ? texts.buttonBackText
                    : texts.buttonText}
                </CreateActivelButton>

                <ConfirmModal
                  isOpen={isConfirmModalOpen}
                  onClose={() => {
                    setIsConfirmModalOpen(false);
                  }}
                />
              </ContentBotton>
            </Container>
          )}
        </ContainerStyled>
      </MainLayout>
    </>
  );
};

export default Revisao;
